import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Heading } from "./NKDaily";

export default function ReportsAdmin() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/reports").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6">
      <Heading title="Reports" subtitle="Flagged chat messages and suspicious match reports." />
      <div className="nk-card">
        {rows.length === 0 ? (
          <div className="px-6 py-10 text-center text-nk-mute text-sm">No open reports.</div>
        ) : rows.map((r, i) => (
          <div key={i} className="px-4 py-3 border-b border-nk-line/40">
            <p className="text-[11px] text-nk-mute font-mono uppercase tracking-wider mb-1">
              {r.reporter_id} → {r.msg_id || r.match_id || "—"}
            </p>
            <p className="text-sm">{r.reason}</p>
            {r.status && <p className="text-[11px] text-nk-dim mt-1">Status: {r.status}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
